import { useCallback } from 'react'

import type { IAutoReviewMissingField } from '@user/store/draftLeads/typings'

import type { UpdateRequiredFieldsFormModel } from '../typings'
import { validateUpdateRequiredFields } from '../utils/validateUpdateRequiredFields'

interface Props {
  /** Only the fields the modal can edit; non-editable ones must never block Save. */
  editableMissing: IAutoReviewMissingField[]
}

/** Wraps validateUpdateRequiredFields for Formik's `validate`. */
export function useValidate(props: Props) {
  const { editableMissing } = props

  return useCallback(
    (values: UpdateRequiredFieldsFormModel) =>
      validateUpdateRequiredFields(values, editableMissing),
    [editableMissing],
  )
}
